module.exports = [{
      plugin: require('/home/anima/web/edu.animaespacio.org/edu.anima/node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/anima/web/edu.animaespacio.org/edu.anima/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
